<template>
  <div>
    <div class="ai-comment" v-if="this.data">
      <div class="data-title">饮食数据</div>
      <div class="cal-container">
        <div class="cal-top"
          ><span>总热量约</span
          ><span class="cal-top-num">{{
            (data.statistics && data.statistics.calorie_sum) || 0 | filterNum
          }}</span
          ><span class="cal-top-unit">kcal</span>
        </div>
        <div class="cal-line">
          <div
            class="cal-line-item"
            :style="{
              background: item.linearColor,
              width: calLineData[index].width
            }"
            v-for="(item, index) in calTypeList"
            :key="index"
          ></div>
        </div>
        <div class="cal-list">
          <div
            class="cal-item"
            v-for="(item, index) in calTypeList"
            :key="index"
          >
            <div class="cal-item-top">
              <div
                class="cal-color"
                :style="{ backgroundColor: item.color }"
              ></div>
              <div class="cal-name">{{ item.name }}</div>
            </div>
            <div class="cal-item-text">{{ item.num | filterNum }}g</div>
          </div>
        </div>
      </div>
      <div>
        <div class="diet-title">饮食菜单</div>
        <div class="menu-list">
          <div
            class="menu-item"
            v-for="(item, index) in data.food"
            :key="index"
          >
            <div class="normal-food" v-if="item.mf == 'n'">
              <div class="food-info">
                <div class="info-top">
                  <!--   <div class="food-status"></div> -->
                  <div class="food-name">{{ item.n }}</div>
                </div>
                <div class="food-bottom">
                  <!-- 一个约250g -->
                  <div class="food-b-left"
                    >{{ item.p }}{{ item.pu }}/约{{ item.w | filterNum
                    }}{{ item.wu }}</div
                  >
                  <div class="food-b-right"
                    ><span>约</span
                    ><span class="cal-num">{{
                      (item.cpt && item.cpt.cl) || 0 | filterNum
                    }}</span
                    ><span class="cal-unit">kcal</span></div
                  >
                </div>
              </div>
              <!-- <div class="item-content">
            <div class="item-title">主要食材</div>
            <div class="item-text">贝果、菠萝、牛肉、鸡蛋、蔬菜</div>
          </div> -->
              <div class="item-content" v-if="item.cpt">
                <div class="item-title">主要营养成分及含量（每100g）</div>
                <div class="nutrition-list">
                  <div class="nutrition-item">
                    <div>蛋白质</div>
                    <div class="item-dashed"></div>
                    <div>{{ item.cpt.pt || 0 | filterNum }}g</div>
                  </div>
                  <div class="nutrition-item">
                    <div>脂肪</div>
                    <div class="item-dashed"></div>
                    <div>{{ item.cpt.f || 0 | filterNum }}g</div>
                  </div>
                  <div class="nutrition-item">
                    <div>碳水化合物</div>
                    <div class="item-dashed"></div>
                    <div>{{ item.cpt.c || 0 | filterNum }}g</div>
                  </div>
                </div>
              </div>
              <div class="item-content" v-if="item.ns">
                <div class="item-title">营养价值分析</div>
                <div class="item-text">{{ item.ns }}</div>
              </div>
              <div class="item-content" v-if="item.hs">
                <div class="item-title">健康建议</div>
                <div class="item-text">{{ item.hs }}</div>
              </div>
            </div>
            <div class="mysterious-food" v-else>
              <div class="food-info">
                <div class="info-top">
                  <!--   <div class="food-status"></div> -->
                  <div class="item-icon">!</div>
                  <div class="item-flex-1">
                    <div class="food-name">{{ item.n }}</div>
                    <div class="m-text">（未知食物）</div>
                  </div>
                  <div class="item-cal">--</div>
                </div>
              </div>
              <div class="tip">这可能是某种未知的神秘食物，小唯暂无法分析</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty" v-else>
      <img
        class="empty-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/450ae7ef590773964e7ca42a994b2e35.png"
        alt=""
      />
      <div>暂无Ai点评</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  components: {},
  data() {
    return {}
  },
  filters: {
    filterNum(num) {
      console.log(num)
      return parseFloat((+num).toFixed(1))
    }
  },
  computed: {
    calTypeList() {
      let list = [
        {
          name: '蛋白质',
          color: 'rgba(48, 48, 56, 1)',
          linearColor: 'linear-gradient( 270deg, #565E7A 0%, #373A56 100%)',
          num: this.data?.statistics.protein_sum
        },
        {
          name: '碳水化合物',
          color: 'rgba(36, 199, 137, 1)',
          linearColor: 'linear-gradient( 90deg, #21CB88 0%, #60E67F 100%)',
          num: this.data?.statistics.carbon_water_sum
        },
        {
          name: '脂肪',
          color: 'rgba(255, 161, 18, 1)',
          linearColor: 'linear-gradient( 270deg, #FFD571 0%, #FFB521 100%)',
          num: this.data?.statistics.fat_sum
        }
      ]
      return list
    },
    calLineData() {
      let list = this.calTypeList.map((item) => {
        return Object.assign(item)
      })
      let space = 0.0032 //留出间距 1px 总宽度 311px
      let minItem = 0.019 //最小占比 6px
      let totalLength = 1 - space * (this.calTypeList.length - 1) //总宽度占比
      let totalNum = 0 //总克数
      list.map((item) => {
        totalNum += item.num
      })
      let realLength = totalLength
      let realNum = totalNum
      list.map((item) => {
        if (item.num / totalNum <= minItem) {
          item.width = minItem
          realLength -= minItem
          realNum -= item.num
        }
      })
      list.map((item) => {
        if (!item.width) {
          item.width = realLength * (item.num / realNum)
        }
      })
      list.map((item) => {
        item.width = item.width * 100 + '%'
      })
      console.log('嘻嘻', list)
      return list
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.ai-comment {
  padding: 20px 16px;
  background: #f5f5f5;
  .data-title {
    font-weight: bold;
    font-size: 16px;
    color: #303038;
    line-height: 22px;
    margin-bottom: 10px;
  }
  .cal-container {
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/828ab5293656b6d773fb6750428124f6.webp');
    background-size: 100%;
    background-repeat: no-repeat;
    padding: 16px;
    margin-bottom: 20px;
    .cal-top {
      margin-bottom: 20px;
      text-align: right;
      font-size: 12px;
      color: #303038;
      line-height: 17px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      .cal-top-num {
        height: 19px;
        margin-left: 4px;
        font-family: DIN;
        font-weight: bold;
        font-size: 18px;
        color: #303038;
        margin-right: 2px;
      }
      .cal-top-unit {
        font-family: DIN;
        font-weight: bold;
        font-size: 19px;
        color: #303038;
        height: 19px;
      }
    }
    .cal-line {
      margin-bottom: 7px;
      height: 16px;
      border-radius: 10px;
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      overflow: hidden;
      .cal-line-item {
        width: 33%;
        background: linear-gradient();
      }
    }
    .cal-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .cal-item {
        .cal-item-top {
          display: flex;
          align-items: center;
          .cal-color {
            width: 5px;
            height: 8px;
            background: #303038;
            border-radius: 1px;
            margin-right: 4px;
          }
          .cal-name {
            font-size: 11px;
            color: #303038;
            line-height: 16px;
          }
        }
        .cal-item-text {
          text-align: center;
          font-weight: bold;
          font-size: 12px;
          color: #303038;
          line-height: 17px;
        }
      }
    }
  }
  .diet-title {
    font-weight: bold;
    font-size: 14px;
    color: rgba(48, 48, 56, 0.5);
    line-height: 20px;
    margin-bottom: 10px;
  }
  .menu-list {
    .menu-item {
      margin-bottom: 10px;
      .normal-food {
        background: #ffffff;
        padding: 20px 16px;
        border-radius: 8px;
      }
      .mysterious-food {
        background: #ffffff;
        padding: 20px 16px;
        border-radius: 8px;
        .item-flex-1 {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          display: flex;
          align-items: center;
        }
        .item-cal {
          font-family: DIN;
          font-weight: bold;
          font-size: 18px;
          color: rgba(48, 48, 56, 0.5);
          line-height: 22px;
        }
        .item-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          background: rgba(48, 48, 56, 0.3);
          border-radius: 50%;
          margin-right: 6px;
          color: #fff;
          font-size: 14px;
        }
        .m-text {
          font-size: 12px;
          color: #303038;
        }
        .tip {
          margin-top: 20px;
          font-size: 12px;
          color: rgba(48, 48, 56, 0.7);
          line-height: 20px;
        }
      }
      .food-info {
        padding-bottom: 14px;
        border-bottom: 0.5px solid rgba(48, 48, 56, 0.2);
        .info-top {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .food-status {
            width: 6px;
            height: 6px;
            border-radius: 3px;
            background: #ff2b48;
            margin-right: 6px;
          }
          .food-name {
            max-width: 180px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 18px;
            color: #303038;
            font-weight: bold;
            line-height: 28px;
          }
        }
        .food-bottom {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          .food-b-left {
            font-weight: bold;
            font-size: 14px;
            color: rgba(48, 48, 56, 0.7);
            line-height: 20px;
          }
          .food-b-right {
            font-size: 12px;
            color: #303038;
            line-height: 17px;
            .cal-num {
              margin-left: 3px;
              font-family: DIN;
              font-weight: bold;
              font-size: 30px;
              color: #303038;
              line-height: 36px;
            }
            .cal-unit {
              font-family: DIN;
              font-weight: bold;
              font-size: 18px;
              color: #303038;
              line-height: 22px;
            }
          }
        }
      }
      .item-content {
        padding-top: 16px;
        font-size: 12px;
        color: #303038;
        line-height: 20px;
        .item-text {
          word-break: break-all;
        }
      }
      .item-title {
        font-size: 12px;
        color: rgba(48, 48, 56, 0.5);
        line-height: 17px;
        margin-bottom: 8px;
      }
      .nutrition-list {
        width: 171px;
        .nutrition-item {
          display: flex;
          align-items: center;
          .item-dashed {
            margin: 0px 9px 0px 12px;
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            border-bottom: 1px dashed rgba(48, 48, 56, 0.3);
          }
        }
      }
    }
    .menu-item:last-child {
      margin-bottom: 0px;
    }
  }
}
.empty {
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: rgba(0, 0, 0, 0.5);
  .empty-image {
    width: 214px;
  }
}
</style>
